import { useApp } from "@/context/AppContext";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export default function CurrencySwitcher() {
  const { currency, setCurrency, currencies } = useApp();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="currency-trigger" className="flex items-center gap-2 px-3 py-2 text-[11px] tracking-[0.15em] uppercase border border-white/15 hover:border-gold text-white transition-colors">
        <span>{currency}</span>
        <ChevronDown size={12} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-black border-white/10">
        {currencies.map(c => (
          <DropdownMenuItem
            key={c}
            data-testid={`currency-option-${c}`}
            onClick={() => setCurrency(c)}
            className={`text-white hover:bg-white/5 hover:text-gold ${c === currency ? "text-gold" : ""}`}
          >
            {c}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
